<template>
    <main>
      <tracker-list :infinite-id="infiniteId"
                            @reload="reload" />
    </main>
  </template>
  
  <script>
  import TrackerList from "@components/modules/tracker/list/TrackerList.vue";
  import EventBus from "@packages/event-bus";
  
  export default {
    components: {
      TrackerList,
    },
  
    data() {
      return {
        infiniteId: +new Date(),
      };
    },
    mixins: [],
  
    props: {},
  
    mounted() {
      EventBus.$on("TRACKER_LIST_MODIFIED", this.reload);
      EventBus.$on("RELOAD_TRACKER_LIST", this.reload);
    },

    beforeDestroy() {
      EventBus.$off("TRACKER_LIST_MODIFIED", this.reload);
      EventBus.$off("RELOAD_TRACKER_LIST", this.reload);
    },
  
    methods: {
      async reload() {
        this.infiniteId++;
      },
    },
  
    computed: {},
  };
  </script>
  
  <style lang="scss" scoped>
  </style>